/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminStockItem
 */
export interface InputAdminStockItem {
    /**
     * 
     * @type {string}
     * @memberof InputAdminStockItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof InputAdminStockItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InputAdminStockItem
     */
    type: InputAdminStockItemTypeEnum;
}


/**
 * @export
 */
export const InputAdminStockItemTypeEnum = {
    Drone: 'drone',
    Ammunition: 'ammunition'
} as const;
export type InputAdminStockItemTypeEnum = typeof InputAdminStockItemTypeEnum[keyof typeof InputAdminStockItemTypeEnum];


/**
 * Check if a given object implements the InputAdminStockItem interface.
 */
export function instanceOfInputAdminStockItem(value: object): boolean {
    if (!('name' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function InputAdminStockItemFromJSON(json: any): InputAdminStockItem {
    return InputAdminStockItemFromJSONTyped(json, false);
}

export function InputAdminStockItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminStockItem {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'name': json['name'],
        'type': json['type'],
    };
}

export function InputAdminStockItemToJSON(value?: InputAdminStockItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'name': value['name'],
        'type': value['type'],
    };
}

